// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__QVGcy","cell":"ColumnAccessor_cell__3HBHX","firstCellAccent":"ColumnAccessor_firstCellAccent__7ovpD"};